import {
  HOME_LOAN_VERTICAL_CARD,
  MEDICAL_LOANS_VERTICAL_CARD,
  PERSONAL_LOAN_VERTICAL_CARD,
  PERSONAL_LOAN_VERTICAL,
  SWIMMING_LOANS_VERTICAL_CARD,
  TRAVEL_LOANS_VERTICAL_CARD,
  WEDDING_LOANS_VERTICAL_CARD,
  DEBT_CONSOLIDATION_VERTICAL_CARD,
  UNEXPECTED_EXPENSE_VERTICAL_CARD,
  MAJOR_PURCHASE_VERTICAL_CARD,
  OTHER_VERTICAL_CARD,
} from 'types/marketplaceTiles.constants';

export const METADATA_MAP = {
  TRAVEL: {
    text: 'Travel',
    cardName: TRAVEL_LOANS_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=VACATION',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  HOME_IMPROVEMENT: {
    text: 'Home improvement',
    cardName: HOME_LOAN_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=HOME_IMPROVEMENT',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  WEDDING: {
    text: 'Wedding',
    cardName: WEDDING_LOANS_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  MEDICAL: {
    text: 'Medical',
    cardName: MEDICAL_LOANS_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  SWIMMING_POOL: {
    text: 'Swimming Pool',
    cardName: SWIMMING_LOANS_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=MAJOR_PURCHASE',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  OTHER: {
    text: 'Other',
    cardName: PERSONAL_LOAN_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
};

export const MARKETPLACE_CARDS = [
  {
    tileIconKey: 'travel_icon',
    ...METADATA_MAP.TRAVEL,
  },
  {
    tileIconKey: 'new_home_icon',
    ...METADATA_MAP.HOME_IMPROVEMENT,
  },
  {
    tileIconKey: 'celebrate_icon',
    ...METADATA_MAP.WEDDING,
  },
  {
    tileIconKey: 'medical_icon',
    ...METADATA_MAP.MEDICAL,
  },
  {
    tileIconKey: 'pool_icon',
    ...METADATA_MAP.SWIMMING_POOL,
  },
  {
    tileIconKey: 'personal_loan_icon',
    ...METADATA_MAP.OTHER,
  },
];

export const METADATA_MAP_EXP = {
  DEBT_CONSOLIDATION: {
    text: 'Debt consolidation',
    cardName: DEBT_CONSOLIDATION_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=DEBT_CONSOLIDATION',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  HOME_IMPROVEMENT: {
    text: 'Home improvement',
    cardName: HOME_LOAN_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=HOME_IMPROVEMENT',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  MAJOR_PURCHASE: {
    text: 'Major purchase',
    cardName: MAJOR_PURCHASE_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=MAJOR_PURCHASE',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  TRAVEL: {
    text: 'Travel',
    cardName: TRAVEL_LOANS_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=VACATION',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  UNEXPECTED_EXPENSE: {
    text: 'Unexpected expense',
    cardName: UNEXPECTED_EXPENSE_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
  OTHER: {
    text: 'Other',
    cardName: OTHER_VERTICAL_CARD,
    queryParameters: 'loanAmount=2000&loanFor=OTHER',
    vertical: PERSONAL_LOAN_VERTICAL,
    location: 'offers-personal-loan',
  },
};

export const MARKETPLACE_CARDS_EXP = [
  {
    tileIconKey: 'debt_consolidation_icon_exp',
    ...METADATA_MAP_EXP.DEBT_CONSOLIDATION,
  },
  {
    tileIconKey: 'home_improvement_icon_exp',
    ...METADATA_MAP_EXP.HOME_IMPROVEMENT,
  },
  {
    tileIconKey: 'major_purchase_icon_exp',
    ...METADATA_MAP_EXP.MAJOR_PURCHASE,
  },
  {
    tileIconKey: 'travel_icon_exp',
    ...METADATA_MAP_EXP.TRAVEL,
  },
  {
    tileIconKey: 'unexpected_expense_icon_exp',
    ...METADATA_MAP_EXP.UNEXPECTED_EXPENSE,
  },
  {
    tileIconKey: 'other_icon_exp',
    ...METADATA_MAP_EXP.OTHER,
  },
];
